/**
 * Block 10 (2026-05-27): Shared warning-level mapping.
 *
 * Centralized 4-level UA colors + labels + priority для sort.
 * Extracted з inline FopReportsPage:21-26 — reuse у:
 *   - LimitCheckBadge (compact + full modes)
 *   - FopLimitsWidget на HomePage
 *   - Будь-який майбутній widget з 3-level warning logic
 */
export type WarningLevel = 'OK' | 'INFO' | 'WARNING' | 'CRITICAL';

export const WARNING_COLOR: Record<WarningLevel, string> = {
  OK: '#10b981', // green-500
  INFO: '#3b82f6', // blue-500
  WARNING: '#f59e0b', // amber-500
  CRITICAL: '#ef4444', // red-500
};

export const WARNING_LABEL_UA: Record<WarningLevel, string> = {
  OK: 'У нормі',
  INFO: 'Увага',
  WARNING: 'Попередження',
  CRITICAL: 'Критично',
};

export const WARNING_PRIORITY: Record<WarningLevel, number> = {
  CRITICAL: 0,
  WARNING: 1,
  INFO: 2,
  OK: 3,
};
